import {getMessage} from "./selectors";

import fetch from "~/utils/fetch";

export default {
  checkout: ({phone, items, orderId, fields}) =>
    `https://wa.me/${phone}?text=${encodeURIComponent(getMessage(items, orderId, fields))}`,
  hook: (url, {phone, items, orderId, fields}) =>
    fetch(
      "POST",
      url,
      {
        phone,
        items,
        orderId,
        fields,
        message: getMessage(items, orderId, fields),
      },
      {},
      "no-cors",
    )
      .then(() => console.info("Hook sent correctly"))
      .catch(() => console.warn("Hook failed")),
};
